import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { LecturePriorityEnum, LectureStatusEnum, LectureTypeEnum } from 'src/app/submit-lecture/lecture.values';
import { UserAdminVerificationStatusEnum } from 'src/app/users/interfaces/user-values';
import { LocalStorageService } from 'src/app/core/local-storage/local-storage.service';
import { LocalStorageKeys } from '../../../../core/local-storage/local-storage.enum';

export type FilterButton = LectureFilterButton | UserFilterButton;

export interface LectureFilterButton {
  text: string;
  value: LectureStatusEnum | LectureTypeEnum | LecturePriorityEnum | 'everything';
}

export interface UserFilterButton {
  text: string;
  value: UserAdminVerificationStatusEnum | 'everything';
}

@Component({
  selector: 'filter-buttons',
  templateUrl: './filter-buttons.component.html',
  styleUrls: ['./filter-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterButtonsComponent implements OnInit {

  @Input() buttons: FilterButton[];
  @Output() valueChanged = new EventEmitter();
  @Input() value: string;
  @Input() localStorageKey: LocalStorageKeys;

  constructor(private localStorageService: LocalStorageService) { }

  private selectPreviousValueFromStorage(): void {
    const previouslySelectedValue: string | undefined = this.localStorageService.read<string>(this.localStorageKey);
    if (previouslySelectedValue) {
      this.value = previouslySelectedValue;
      this.valueChanged.emit(this.value);
    }
  }

  ngOnInit(): void {
    this.selectPreviousValueFromStorage();
  }

  onChanged(): void {
    if (this.localStorageKey) {
      this.localStorageService.write<string>(this.localStorageKey, this.value);
    }
    this.valueChanged.emit(this.value);
  }
}
